import { InfoCircle } from 'react-bootstrap-icons';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';

function ConfirmIt({ShowConfirm, OnClose,Message, onConfirm}) {
  if (!ShowConfirm) return null; // Conditionally render the container

  const confirmItContainerStyle = {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0.5)', /* Optional: Add a semi-transparent background */
      zIndex: 1050 /* Ensure it appears above other content */
    }

  return (
    <>
    <div style={confirmItContainerStyle}>

      <Alert show={ShowConfirm} variant="info" className='text-center'>
        <Alert.Heading ><InfoCircle/></Alert.Heading>
        <p>{Message}</p>
        <hr />
        <div className="d-flex justify-content-around">
          <Button onClick={onConfirm} variant="outline-success">
            Yes
          </Button>
          <Button onClick={OnClose} variant="outline-danger">
            No
          </Button>
        </div>
      </Alert>
    </div>
    </>
  );
}

export default ConfirmIt;